import { render, staticRenderFns } from "./NewFileDropZone.vue?vue&type=template&id=41b472d2&scoped=true"
import script from "./NewFileDropZone.vue?vue&type=script&lang=js"
export * from "./NewFileDropZone.vue?vue&type=script&lang=js"
import style0 from "./NewFileDropZone.vue?vue&type=style&index=0&id=41b472d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41b472d2",
  null
  
)

export default component.exports